import { FetchBaseQueryError } from '@reduxjs/toolkit/query'

// Statuses fetchBaseQuery reports when fetch() itself threw: no HTTP response arrived, so there is no backend error body to log.
export const NO_RESPONSE_STATUSES: FetchBaseQueryError['status'][] = ['FETCH_ERROR', 'TIMEOUT_ERROR']

// Messages the browser reports when fetch() never produced a usable response. They name no cause: a dropped connection,
// a webview torn down mid-flight and an offline device all arrive as the same string, so there is nothing to act on.
export const OPAQUE_TRANSPORT_ERRORS = ['load failed', 'failed to fetch', 'networkerror']

// Cap on the unparsable response body copied into the Sentry message: a proxy or gateway can answer with a full HTML page.
export const MAX_ERROR_BODY_LENGTH = 200
